import { Price } from 'shared-types/Common';

type AnyObjectWithLabel = {
  [key: string]: any;
  label: any;
};

type AnyObjectWithPrice = {
  [key: string]: any;
  price: Price;
};

type ByLabelProps = (a: AnyObjectWithLabel, b: AnyObjectWithLabel) => number;

const byLabel: ByLabelProps = (a, b) => {
  if (a.last_nom < b.last_nom) {
    return -1;
  }
  if (a.last_nom > b.last_nom) {
    return 1;
  }
  return 0;
};

type ByPriceProps = (a: AnyObjectWithPrice, b: AnyObjectWithPrice) => number;

const byPrice: ByPriceProps = (a, b) => a.price.amount - b.price.amount;

export { byPrice, byLabel };
